import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  prefecturesCollection,
  contactsCollection,
  businessesCollection,
  categoriesCollection,
} from "~/const/firestore";
import { Option } from "~/types/component";
import { convertToOptions } from "~/helpers/snapshot";

// 都道府県データ 取得
export const getPrefectures = createAsyncThunk<Option[], void>(
  "master/prefectures",
  async () => {
    try {
      const snapshot = await prefecturesCollection.get();
      const prefectures = convertToOptions(snapshot);
      return prefectures;
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  }
);

// 連絡方法 取得
export const getContacts = createAsyncThunk<Option[], void>(
  "master/contacts",
  async () => {
    try {
      const snapshot = await contactsCollection.get();
      const contacts = convertToOptions(snapshot);
      return contacts;
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  }
);

// 業態 取得
export const getBusinesses = createAsyncThunk<Option[], void>(
  "master/businesses",
  async () => {
    try {
      const snapshot = await businessesCollection.get();
      const businesses = convertToOptions(snapshot);
      return businesses;
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  }
);

// ノートカテゴリ 取得
export const getCategories = createAsyncThunk<Option[], void>(
  "master/categories",
  async () => {
    try {
      const snapshot = await categoriesCollection.get();
      const categories = convertToOptions(snapshot);
      return categories;
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  }
);
